export default __webpack_public_path__ + "static/media/football-3.0d955804.jpg";